import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/58/thumb-landscape.png"

const Post58 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">PRADA／プラダ シンボル エンブロイダリーファブリック ミニバッグ／W17 x H19 x D6 (cm)</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
            夏の陽射しが降り注ぎ、街が活気に満ち溢れるこの季節。ファッションも軽やかで、けれどどこか洗練されたスタイルを追求したくなりますよね。そんな大人の女性の心を捉えて離さないのが、「プラダ シンボル（Prada Symbole）」バッグです。<br></br><br></br>
            プラダの豊かな歴史と卓越したクラフツマンシップが息づくこのコレクションは、ブランドの象徴であるトライアングルロゴを、ラグジュアリーなジャカード織りでモダンに再解釈したまさに傑作。幾何学的でありながら多面的なデザインは、一目見た瞬間に「プラダ」とわかる存在感を放ち、持つ人の個性を際立たせます。<br></br><br></br>
            今回は、この「プラダ シンボル」バッグの中から、特に注目したい3つのサイズ――「プラダ シンボル エンブロイダリーファブリック ミニバッグ」「プラダ シンボル エンブロイダリーファブリック スモールハンドバッグ」、そして「プラダ シンボル エンブロイダリーファブリック ラージハンドバッグ」に焦点を当て、それぞれの魅力と、この夏ぜひ取り入れてほしいスタイリングのヒントを、たっぷりとお届けします。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;プラダの象徴「プラダ シンボル」バッグとは？</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;シーンで使い分けたい、3つのサイズでつくる、夏の品格スタイル</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec3" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;夏に映える「ミニバッグ」｜コンパクトで上質な存在感</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec4" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;デイリーに頼れる「スモールハンドバッグ」で夏コーデを更新</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec5" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;荷物が多い日もエレガントに｜「ラージハンドバッグ」の魅力</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;まとめ：夏を制する「プラダ シンボル」バッグ、あなたならどのサイズを選ぶ？</ScrollLink><br></br>
          </div>
        </p>
      </div>         
      <figure name="sec1">
        <StaticImage src="../../images/posts/58/1.jpeg" alt=""/>
      </figure>    
      <div className="text-max-width">
        <h1>プラダの象徴「プラダ シンボル」バッグとは？</h1>
      </div>
      <p className="text-max-width">まず、このバッグの最大の魅力である「プラダ シンボル」について深掘りしていきましょう。トライアングルは、1世紀にもわたりプラダが培ってきた卓越した職人技と、一切の妥協を許さない最高品質への証。その歴史と哲学が凝縮されたトライアングルが、現代的なジャカード織りで表現されることで、新たな生命を吹き込まれています。</p>
      <p className="text-max-width">このジャカード織りのテクスチャーは、見る角度や光の当たり方によって表情を変え、まるでアート作品のような奥行きと立体感を生み出します。</p>
      <figure>
        <StaticImage src="../../images/posts/58/2.jpeg" alt=""/>
      </figure>   
      <p className="text-max-width space-bottom">そして、上品な光沢を放つ「サフィアーノ（Saffiano）」レザーのトリムが、バッグ全体をぐっと引き締め、ラグジュアリーなオーラを纏わせているんです。多用途に使えるバッグとして展開されているのも、現代の女性のライフスタイルに寄り添うプラダならではの配慮と言えるでしょう。</p>
      <div name="sec2" className="img-three-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/58/3.jpg"/>
          <span className="text-center">
            ミニ<br></br>
            17 x 19 x 6 cm
          </span>  
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/58/5.jpg"/>
          <span className="text-center">
            スモール<br></br>
            28 x 21 x 9 cm
          </span>  
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/58/7.jpg"/>
          <span className="text-center">
            ラージ<br></br>
            39 x 30 x 10 cm
          </span>  
        </figure>
      </div>
      <div className="text-max-width">
        <h1>シーンで使い分けたい、3つのサイズでつくる、夏の品格スタイル</h1>
      </div>
      <p className="text-max-width">さて、いよいよ本題の3つのサイズについて詳しく見ていきましょう。それぞれのサイズが持つ個性と、夏のファッションにおける役割を解説します。</p>
      <div name="sec3" className="text-max-width">
        <h2>◆ 夏に映える「ミニバッグ」｜コンパクトで上質な存在感</h2>
      </div>
      <p className="text-max-width space-bottom">「プラダ シンボル エンブロイダリーファブリック ミニバッグ」は、その名の通り、愛らしいミニマムなサイズ感が魅力。夏の軽やかな装いに、さりげなく上質感を添えてくれる存在です。スマートフォン、ミニ財布、リップスティックなど、必要最低限のものをスマートに収納できるコンパクトさは、身軽に動きたい夏のシーンにぴったり。このミニバッグは、まさに夏の装いを「わかってる」大人の女性のためのアイテム。</p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/58/3.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/58/4.jpg"/>
        </figure>
      </div>
      <span className="text-center space-bottom">PRADA／プラダ シンボル エンブロイダリーファブリック ミニバッグ／W17 x H19 x D6 (cm)</span>  
      <p className="text-max-width">
        清涼感と華やかさを兼ね備えたホワイトドレスを主役に、リゾートらしいナチュラルさと上品さを絶妙にミックスしたスタイリング。<br></br>
        小物でさりげなくリゾート感を添えることで、特別感のあるディナータイムにもふさわしい装いに仕上がっています。<br></br>
        そこにブラックとベージュのジオメトリック柄バッグを合わせれば、ドレスにモダンな印象が加わり、スタイル全体がより洗練された印象に。小さめの縦長トート型はリゾートでも使いやすく、エレガントなムードを演出してくれる頼れるアイテムです。
      </p>
      <div className="text-max-width">
        <h2><span className="text-border-bottom text-font-bolder">こんな方におすすめ</span></h2>
      </div>  
      <ul className="list-style-disc">
        <li style={{marginTop: "2rem"}}>リゾート地でもカジュアルすぎず、上品にディナーを楽しみたい。</li>
        <li style={{marginTop: "2rem"}}>写真映えする爽やかでクラシカルなスタイルを求めている。</li>
        <li style={{marginTop: "2rem"}}>荷物が多くならないコンパクトなバッグでスマートに過ごしたい。</li>
      </ul>
      <div name="sec4" className="text-max-width">
        <h2>◆ デイリーに頼れる「スモールハンドバッグ」で夏コーデを更新</h2>
      </div>
      <p className="text-max-width space-bottom">続く「プラダ シンボル エンブロイダリーファブリック スモールハンドバッグ」は、日常使いに最適な、絶妙なサイズ感が魅力。A5サイズの手帳やポーチ、小さめのタブレットなども収納でき、オンオフ問わず活躍してくれる万能選手です。取り外し可能なショルダーストラップが付いているので、気分やコーディネートに合わせてハンドバッグとしてもショルダーバッグとしても使えるのが嬉しいポイント。</p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/58/5.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/58/6.jpg"/>
        </figure>
      </div>
      <span className="text-center space-bottom">PRADA／プラダ シンボル エンブロイダリーファブリック スモールハンドバッグ／W28 x H21 x D9 (cm)</span>  
      <p className="text-max-width">シンプルで落ち着いた色合わせながらも、程よい抜け感と女性らしさを演出したスタイルは、カフェやショッピング、友人とのランチなど、幅広い休日のシーンにおすすめです。ラフすぎず、きちんと見えるのが魅力です。</p>
      <p className="text-max-width">このコーディネートのアクセントとなるのが、ジオメトリック柄のバッグです。モダンな印象を添え、程よい華やかさをプラスしてくれます。また、その絶妙なサイズ感は、オンオフ問わず活躍すること間違いなし。使いやすさも抜群なので、きっと出番の多いバッグになるでしょう。</p>
      <div className="text-max-width">
        <h2><span className="text-border-bottom text-font-bolder">こんな方におすすめ</span></h2>
      </div>  
      <ul className="list-style-disc">
        <li style={{marginTop: "2rem"}}>きれいめだけど肩の力が抜けた休日スタイルを楽しみたい。</li>
        <li style={{marginTop: "2rem"}}>ショッピングやカフェなど、移動が多い日も動きやすくおしゃれに過ごしたい。</li>
        <li style={{marginTop: "2rem"}}>ベーシックカラーでまとめたいけれど、どこかにポイントが欲しい。</li>
      </ul>
      <div name="sec5" className="text-max-width">
        <h2>◆ 荷物が多い日もエレガントに｜「ラージハンドバッグ」の魅力</h2>
      </div>
      <p className="text-max-width space-bottom">そして最後に、堂々たる存在感を放つ「プラダ シンボル エンブロイダリーファブリック ラージハンドバッグ」。その大容量は、夏のあらゆるシーンで頼りになること間違いなし。荷物が多い日の家族とのお出かけバッグとしても、ファッション性を損なわずに活躍してくれます。</p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/58/7.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/58/8.jpg"/>
        </figure>
      </div>
      <span className="text-center space-bottom">PRADA／プラダ シンボル エンブロイダリーファブリック ラージハンドバッグ／W39 x H30 x D10 (cm)</span>  
      <p className="text-max-width">モダンなジオメトリック柄ラージハンドバッグを主役に、シンプルながらもこなれたデニムワンピースを合わせることで、リラックスしつつも洗練された雰囲気に仕上がります。</p>
      <p className="text-max-width">このバッグは、大容量でありながらもモダンなデザインによってスマートな印象を与えるのがプラダならでは。荷物が多くなりがちな家族とのお出かけでも、カーディガンや薄手のストールといった温度調整用の羽織り物はもちろん、ショッピングで増える荷物も無理なく収納できます。これ一つで、おしゃれを妥協することなく、快適に過ごせるでしょう。</p>
      <div className="text-max-width">
        <h2><span className="text-border-bottom text-font-bolder">こんな方におすすめ</span></h2>
      </div>  
      <ul className="list-style-disc">
        <li style={{marginTop: "2rem"}}>子どもと一緒でもおしゃれを楽しみたいママパパ。</li>
        <li style={{marginTop: "2rem"}}>動きやすさと大人のカジュアル感を両立したい。</li>
        <li style={{marginTop: "2rem"}}>大きめバッグで荷物が多くても安心したい。</li>
      </ul>
      <div name="sec6" className="text-max-width">
        <h1>まとめ：夏を制する「プラダ シンボル」バッグ、あなたならどのサイズを選ぶ？</h1>
      </div>
      <p className="text-max-width">
        「プラダ シンボル」バッグは、プラダの歴史と現代性が融合した、まさにタイムレスな魅力を持つ逸品です。象徴的なトライアングルモチーフが織りなすラグジュアリーなジャカードは、持つ人の品格と個性を際立たせ、夏のあらゆるシーンであなたを主役にしてくれるでしょう。<br></br>
        どのサイズを選んでも、あなたの夏の装いは間違いなくワンランク上の洗練されたスタイルへと昇華されるはずです。
      </p>
      <p className="text-max-width">
        この夏、どのサイズを選びますか？<br></br>
        小さくて潔いミニサイズ。<br></br>
        万能なスモールサイズ。<br></br>
        頼れるラージサイズ。
      </p>
      <p className="text-max-width">さあ、この夏、あなただけの「プラダ シンボル」を見つけて、最高のファッションストーリーを始めてみませんか？</p>
      <div className="border"></div> 
      <p className="text-max-width">📱憧れを日常に──ラクサスでプラダを体験しよう！</p>     
      <Link to="https://laxus.co/app/pc/bags/prada" className="view-all-button">
        プラダのバッグはこちら
      </Link>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post58

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 58}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`